import { render, staticRenderFns } from "./OnboardingPlans.vue?vue&type=template&id=313c385f&scoped=true"
import script from "./OnboardingPlans.vue?vue&type=script&lang=js"
export * from "./OnboardingPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c385f",
  null
  
)

export default component.exports